module.exports = __webpack_public_path__ + "static/media/yt.6e6734ff.png";